<div
	*ngIf="currentStep === 1"
	class="flex flex-col items-center justify-center pt-6 pb-10 xl:pt-16 dark-grey-texts"
>
	<div class="w-[100%] md:w-[80%] xl:w-[60%]">
		<div class="flex justify-between items-center pl-6 pr-6 md:pl-0 md:pr-0">
			<h1
				class="dark-grey-texts reset-spacing"
				i18n="@@title_stripe_verification"
			>
				Stripe Verification
			</h1>
		</div>
		<div
			class="flex flex-col justify-start md:rounded-lg p-6 mt-4 border border-solid border-color gap-1"
		>
			<div class="flex flex-col mb-2">
				<span class="text-20 font-500" i18n="@@select_country_label_setCountry"
					>Set Country</span
				>
			</div>
			<div class="flex flex-col mb-3">
				<div class="inline">
					<span i18n="@@select_country_label_chooseLocation"
						>Select the country where you'll receive funds.</span
					>&nbsp;
					<a
						[href]="countryLinkHref"
						target="_blank"
						rel="noopener"
						class="link-decorate-style pointer inline underline"
						i18n="@@select_country_label_countriesSupported"
					>
						<span>(</span><span>List of supported countries</span><span>)</span>
					</a>
				</div>
			</div>
			<div class="flex flex-col w-full">
				<mat-form-field appearance="outline">
					<mat-label i18n="@@selectCountry_page_dropdown_placeholder"
						>Select Country</mat-label
					>
					<input
						type="text"
						matInput
						[formControl]="countrySearchControl"
						[matAutocomplete]="auto"
						placeholder="Start typing to search..."
					/>
					<button mat-icon-button matSuffix tabindex="-1">
						<mat-icon>arrow_drop_down</mat-icon>
					</button>
					<mat-autocomplete
						#auto="matAutocomplete"
						(optionSelected)="onCountrySelect($event)"
					>
						<mat-option
							*ngFor="let country of filteredCountries | async"
							[value]="country"
						>
							{{ country }}
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>
			</div>
			<div class="flex flex-col w-full">
				<mat-form-field appearance="outline">
					<mat-label i18n="@@select_businessType_label"
						>Select Business Type</mat-label
					>
					<mat-select
						[(value)]="selectedBusinessType"
						[disabled]="!selectedCountry"
					>
						<mat-option
							*ngFor="let type of availableBusinessTypes"
							[value]="type.value"
						>
							{{ type.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="flex flex-col qrCodeBackground p-5 gap-1">
				<div class="flex w-full items-center justify-start mb-2">
					<div class="flex items-center gap-3">
						<img
							src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/blueInfo/public"
							alt="Info"
						/>
						<span
							class="text-20 font-500"
							i18n="@@create_fundraiser_important_information_title"
							>Important Information</span
						>
					</div>
				</div>
				<div class="flex">
					&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;<span
						i18n="@@select_country_label_countryBusinessType_label1"
						>Country and business type can't be changed after publishing.
					</span>
				</div>
				<div class="flex">
					&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;<span
						i18n="@@select_country_label_countryBusinessType_label2"
						>We're working to expand to more countries soon! For now, please
						choose your country from the list above.
					</span>
				</div>
				<div class="flex">
					&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;<span
						i18n="@@select_country_label_countryBusinessType_label3"
						>The person or organization managing the fundraiser must be from the
						same country.
					</span>
				</div>
			</div>
			<div class="flex flex-col justify-center items-end mt-5">
				<button
					mat-flat-button
					color="accent"
					(click)="saveCountry()"
					[disabled]="
						!selectedCountry || !selectedBusinessType || isStripeLoading
					"
					class="w-100 sm:w-auto"
				>
					<div class="flex items-center justify-center gap-2">
						<span class="text-14 font-500 p-0" i18n="@@button_next">Next</span>
						<mat-icon *ngIf="isStripeLoading" class="mt-1">
							<mat-spinner color="accent" diameter="18"> </mat-spinner>
						</mat-icon>
					</div>
				</button>
			</div>
		</div>
	</div>
</div>

<div
	*ngIf="currentStep === 2"
	class="flex flex-col items-center justify-center pt-6 pb-10 xl:pt-16 dark-grey-texts"
>
	<div class="w-[100%] md:w-[80%] xl:w-[60%]">
		<div class="flex justify-between items-center pl-6 pr-6 md:pl-0 md:pr-0">
			<h1
				class="dark-grey-texts reset-spacing"
				i18n="@@title_stripe_verification"
			>
				Stripe Verification
			</h1>
		</div>
		<div
			class="flex flex-col justify-start md:rounded-lg pl-6 pr-6 mt-4 border border-solid border-color gap-1"
		>
			<app-stripe-embeded></app-stripe-embeded>
		</div>
	</div>
</div>
